import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
interface IProps {
  currentStep: number;
  onNext: () => void;
  onPrevious: () => void;
  canNext: boolean;
  canPrevious: boolean;
  steps: number;
}
const StepsNav = ({
  currentStep,
  onPrevious,
  onNext,
  canNext,
  canPrevious,
  steps
}: IProps) => {
  return (
    <Container>
      <Button
        isactive={canPrevious ? "true" : "false"}
        onClick={() => {
          if (canPrevious) {
            onPrevious();
          }
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            d="M13 4.1665L8 9.99984L13 15.8332"
            stroke={canPrevious ? Colors.grey900 : Colors.grey100}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <Typography
          weight="medium"
          color={canPrevious ? Colors.grey900 : Colors.grey100}
          ml="0.8"
        >
          Previous
        </Typography>
      </Button>
      <Steps>
        {new Array(steps).fill("").map((step, i) => {
          const status = i + 1 === currentStep ? "active" : "";
          return (
            <StepNo status={status} key={i}>
              <Typography
                color={status === "active" ? Colors.white100 : Colors.grey500}
              >
                {i + 1}
              </Typography>
            </StepNo>
          );
        })}
      </Steps>
      <Button
        isactive={canNext ? "true" : "false"}
        onClick={() => {
          if (canNext) {
            onNext();
          }
        }}
      >
        <Typography
          weight="medium"
          color={canNext ? Colors.grey900 : Colors.grey100}
          mr="0.8"
        >
          {currentStep < steps ? "Next" : "Finish"}
        </Typography>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            d="M8 4.1665L13 9.99984L8 15.8332"
            stroke={canNext ? Colors.grey900 : Colors.grey100}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </Button>
    </Container>
  );
};

export default StepsNav;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.4rem 0;
  border-top: 1px solid ${Colors.grey700};
`;

const Button = styled.div<{ isactive: string }>`
  cursor: ${(props) => (props.isactive === "true" ? "pointer" : "not-allowed")};
  width: fit-content;
  padding: 0.8rem 1.6rem;
  background-color: ${(props) =>
    props.isactive === "true" ? Colors.yellow500 : Colors.grey600};
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  transition: all ease-in-out 0.2s;
`;
const Steps = styled.div`
  display: flex;
  align-items: center;
`;
const StepNo = styled.div<{ status: string }>`
  margin-right: 1rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background-color: ${(props) =>
    props.status === "active" ? Colors.yellow400 : Colors.grey600};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ease-in-out 0.2s;
`;
